import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=77221776&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"
import style0 from "./RichText.vue?vue&type=style&index=0&id=77221776&prod&lang=scss&scoped=true"
import style1 from "./RichText.vue?vue&type=style&index=1&id=77221776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77221776",
  null
  
)

export default component.exports